export default {
  name: 'DatasetModuleBase',
  props: {
    store: { type: Object, default: () => null },
    row: { type: Object, default: () => ({}) },
    column: { type: Object, default: () => ({}) },
    value: {
      type: [String, Number, Boolean, Array, Object, Date],
      default: () => null,
    },
    addons: { type: Object, default: () => ({}) },
    meta: { type: Object, default: () => null },
    updateMeta: { type: Function, default: () => null },
    forceFetch: { type: Function, default: () => null },
  },
}
